import { Contact as ContactPage } from "~landing/components/contact/contact";
import { Layout } from "~landing/components/layout";

export function Contact() {
	return (
		<Layout>
			<main>
				<ContactPage />
			</main>
		</Layout>
	);
}
